namespace $.$$ {
	$mol_style_define($bog_blitz_admin_question, {
		background: {
			color: $mol_theme.card,
		},
		border: {
			radius: '0.5rem',
		},
		padding: {
			top: '0.5rem',
			bottom: '0.5rem',
			left: '0.75rem',
			right: '0.75rem',
		},
		Header: {
			gap: '0.25rem',
		},
		Delete: {
			color: '#cc3333',
		},
		Options_section: {
			padding: {
				top: 0,
				bottom: 0,
				left: '1rem',
				right: 0,
			},
			gap: '0.5rem',
		},
		Add_option: {
			align: {
				self: 'flex-start',
			},
		},
		Image_section: {
			align: {
				items: 'center',
			},
			gap: '0.5rem',
		},
		Image_upload: {
			Native: {
				top: 0,
				height: '100%',
			},
		},
		Image_preview: {
			maxHeight: '8rem',
			maxWidth: '12rem',
			border: {
				radius: '0.25rem',
			},
			overflow: 'hidden',
		},
	})
}
